var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"16/Chevron_left"},React.createElement("path",{"id":"Vector (Stroke)","fillRule":"evenodd","clipRule":"evenodd","d":"M9.70923 4.04048C9.96307 4.29432 9.96307 4.70588 9.70923 4.95972L6.66885 8.0001L9.70923 11.0405C9.96307 11.2943 9.96307 11.7059 9.70923 11.9597C9.45539 12.2136 9.04383 12.2136 8.78999 11.9597L5.28999 8.45972C5.03615 8.20588 5.03615 7.79432 5.28999 7.54048L8.78999 4.04048C9.04383 3.78664 9.45539 3.78664 9.70923 4.04048Z","fill":"#82888E"})));
}

ChevronLeft.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
